export const DRAW_AREA_UPDATE = 'DRAW_AREA_UPDATE';
export const DRAW_AREA_TOGGLE_VISIBILITY = 'DRAW_AREA_TOGGLE_VISIBILITY';
export const DRAW_AREA_SET_SIZES = 'DRAW_AREA_SET_SIZES';
export const DRAW_AREA_SET_MIN_SIZES = 'DRAW_AREA_SET_MIN_SIZES';
export const DRAW_AREA_SET_MOUSE_DOWN = 'DRAW_AREA_SET_MOUSE_DOWN';
export const DRAW_AREA_RESET = 'DRAW_AREA_RESET';
export const DRAW_AREA_SHIFT_HOLD = 'DRAW_AREA_SHIFT_HOLD';
export const DRAW_AREA_SHIFT_RELEASE = 'DRAW_AREA_SHIFT_RELEASE';
export const SET_SHOULD_DRAG_LAYER = 'SET_SHOULD_DRAG_LAYER';
